import { TypographyOptions } from '@mui/material/styles/createTypography'
import { ThemeOptions } from '@mui/material'
import {
  MuiTypographyExtensions,
  OriginalTypographyVariants,
  TypographyVariantMapping,
} from './theme'

export default function typography(
  theme: ThemeOptions,
): TypographyOptions & TypographyVariantMapping {
  // These are the default typography options, I purposely omit the extras i've defined through extensions
  const typography: OriginalTypographyVariants = {
    fontFamily: theme.fonts?.defaultFontFamily,
    h1: {
      fontFamily: theme.fonts?.h1FontFamily,
      fontSize: '2.25rem',
      lineHeight: '45px',
      color: theme.colors?.primary500,
      textTransform: 'uppercase',
    },
    h2: {
      fontWeight: 600,
      fontSize: '1.75rem',
      lineHeight: '33.6px',
      color: theme.colors?.primary500,
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: '28.8px',
      color: theme.colors?.primary500,
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: '24px',
      color: theme.colors?.primary500,
    },
    h5: {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: '24px',
      letterSpacing: '0.02rem',
      color: theme.colors?.primary500,
    },
    h6: {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: '24px',
      color: theme.colors?.primary500,
    },
    subtitle1: {
      fontWeight: 700,
      fontSize: '1.5rem',
      lineHeight: '36px',
      color: theme.colors?.grey800,
    },
    subtitle2: {
      fontWeight: 500,
      fontSize: '1.25rem',
      lineHeight: '30px',
      color: theme.colors?.grey800,
    },
    body1: {
      fontWeight: 400,
      fontSize: '1.125rem',
      lineHeight: '30px',
      color: theme.colors?.grey800,
    },
    body2: {
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: '24px',
      color: theme.colors?.grey800,
    },
    button: {
      fontWeight: 700,
      fontSize: '1rem',
      lineHeight: '24px',
    },
    caption: {
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: '21px',
      color: theme.colors?.grey800,
    },
  }

  // Add Typography extensions here, the type mapping will make it available through <Typography variant="NEW_TYPE_ADDED">
  // Semantics should be supplied for every extra variant defined in MuiTypographyExtensions inside defaultProps.
  // E.g Display is a semantic H1
  const extensions: TypographyVariantMapping & MuiTypographyExtensions = {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          display: 'h1',
          link: 'p',
          small: 'span',
        },
      },
    },
    small: {
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: '18px',
    },
    link: {
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '150%' /* 1.5rem */,
      textDecorationLine: 'underline',
      textDecorationThickness: '1px',
      textUnderlineOffset: '3px',
    },
    display: {
      fontFamily: theme.fonts?.h1FontFamily,
      fontSize: '2.25rem',
      lineHeight: '45px',
      color: theme.colors?.primary500,
      textTransform: 'uppercase',
      fontWeight: 300,
    },
  }

  return { ...typography, ...extensions }
}
